module.exports = __webpack_public_path__ + "static/media/assessmentPhoto.78d83ab6.png";